import React, { useState, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

function ContactForm({ Receiveemail }) {
  const recaptchaRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    country: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const receiveEmail = Receiveemail; // receiver email

const isPrerender =
  navigator.userAgent.includes("ReactSnap") ||
  navigator.userAgent.includes("HeadlessChrome");


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = recaptchaRef.current?.getValue();

    if (!token) {
      setStatus("❌ Please verify reCAPTCHA");
      return;
    }

    try {
      const response = await fetch("https://rbhardwaj.com/formsend.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...formData,
          receiveemail: receiveEmail,
          recaptcha: token,
        }),
      });

      const result = await response.json();

      if (result.success) {
        setStatus("✅ Mail sent successfully!");
        setFormData({
          name: "",
          email: "",
          mobile: "",
          country: "",
          message: "",
        });
        recaptchaRef.current.reset();
        alert(
          "Your mail was sent successfully! The team will contact you soon."
        );
      } else {
        setStatus("❌ " + result.error);
      }
    } catch (error) {
      setStatus("⚠️ Error: " + error.message);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="formlabeldiv">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <label>Name</label>
        </div>

        <div className="input-group">
          <div className="formlabeldiv">
            <input
              type="text"
              pattern="[6-9]{1}[0-9]{9}"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              required
            />
            <label>Phone Number</label>
          </div>

          <div className="formlabeldiv">
            <input
              type="email"
              name="email"
              pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <label>Email</label>
          </div>
        </div>

        <div className="formlabeldiv">
          <input
            type="text"
            name="country"
            value={formData.country}
            onChange={handleChange}
            required
          />
          <label>Country</label>
        </div>

        <div className="formlabeldiv">
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
          <label>Message</label>
        </div>

        <div style={{ margin: "15px 0" }}>
             {/* {!isPrerender && (
     <ReCAPTCHA
            sitekey=""
            ref={recaptchaRef}
          />
)} */}
        </div>



        <input type="submit" value="Submit" />
      </form>

      <p style={{ color: "green" }}>{status}</p>
    </div>
  );
}

export default ContactForm;